export function isValidEmail(value: string): boolean {
  const normalized = String(value).trim();
  if (normalized === '') {
    return false;
  }

  let html5Ok = true;
  try {
    const input = document.createElement('input');
    input.setAttribute('type', 'email');
    input.value = normalized;
    if (typeof input.checkValidity === 'function') {
      html5Ok = input.checkValidity();
    }
  } catch {
    html5Ok = false;
  }

  return html5Ok && /\.[A-Za-z]{2,}$/.test(normalized);
}
